import { CoreApiVersionPath, RosaCoreApiService } from '@/rosa';
import type { Language } from '@/utils/i18n/language.interface';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import type { ReferenceListItem, ReferenceListName } from './reference-lists.interface';

@Injectable({
    providedIn: 'root'
})
export class AdvizeoCoreReferenceListsService {
    private _coreApiService = inject(RosaCoreApiService);

    fetchReferenceLists$(lang: Language, lists: ReferenceListName[]): Observable<Partial<Record<ReferenceListName, ReferenceListItem[]>>> {
        return this._coreApiService.get(
            `${CoreApiVersionPath.V3}reference-list?lang=${lang}${lists.map(list => `&type=${list}`).join('')}`
        );
    }
}
